import styled from "styled-components";

export default function Input({ change, refTo, type, placeholder, require }) {
  return (
    <StyledInput
      onChange={change}
      ref={refTo}
      style={{ textAlign: "center" }}
      type={type}
      placeholder={placeholder}
    />
  );
}

const StyledInput = styled.input`
  /* background: rgba(18, 18, 19, 0.836); */

  background-color: transparent;
  box-shadow: 0px 0px 30px 0px rgba(28, 28, 29, 0.37);
  border-radius: 0px;
  width: 100%;
  height: 3rem;
  padding: 0.1rem 0.4rem 0.1rem 0.4rem;
  border: 0px solid #f6f6f8;
  outline: none;
  margin: 8px;
  color: #fcfcfb;
  font-size: 1rem;
  font-weight: bold;
  &:focus {
    display: inline-block;
    box-shadow: 0 0 0 0.1rem #eaeee6;
    backdrop-filter: blur();
    border-radius: 10px;
  }
  &::placeholder {
    color: #fad28775;
    font-weight: 100;
    font-size: 1rem;
  }
`;
